module.exports = __webpack_public_path__ + "img/detection_03_thermal.bc22275a.jpg";